<template>
	<div class="nav">
		<a class="logo" href="#/home"><img src="@/assets/logo1.png"></a>
		<div class="items left-info" style="margin-right: 20px;">香港訂購 Hong Kong Order</div>
		<div class="items">
			<div class="left-info" v-if="userInfo && userInfo.value">
				歡迎您Welcome {{userInfo.value.binding.name}} ({{userInfo.value.binding.register.vip_no}})
				<span class="sep">|</span>
				<a class="unLogin" @click="logout">退出登錄(Log out)</a>
			</div>
		</div>
		<!-- <div class="search"></div> -->
		<div class="items"style="flex: 1;justify-content: flex-end;">
			<div  @click='goUrl("/home")' class="item" :class='{active:activeIndex=="WSFT_Product"}' @mouseenter="hoverActive=-1">
				<span class="title"><span class="zh">首頁</span><span class="en">(Home)</span></span>
			</div>
			<span class="sep1">|</span>
			<div class="item" @mouseenter='hoverActive="WSFT_Shopcart"'>
				<Badge :count="cartCount" type="primary"  :offset='[-10,-50]'>
       				<a class="demo-badge"></a>
    			</Badge>
				<span class="title"><span class="zh">購物車</span><span class="en">(Cart)</span></span>
			</div>
			<span class="sep1">|</span>
			<div class="item" :class='{active:activeIndex=="WSFT_Orders"}' @mouseenter='hoverActive="WSFT_Personal"'>
				<span class="title"><span class="zh">個人中心</span><span class="en">(Personal Center)</span></span>
			</div>
			<!-- <span class="sep1">|</span>
			<div class="item" @mouseenter="hoverActive=-1">
				<span class="title"><span class="zh">返回我的ō</span><span class="en">(Return Myō)</span></span>
			</div> -->
			<div @mouseleave="hoverActive=-1">
				<Cart :showCart='hoverActive == "WSFT_Shopcart"' @showCustomer='showCustomer' @showPromoCode='showPromoCode'></Cart>
			</div>
			<div class="contact" @mouseleave="hoverActive=-1" v-if='hoverActive == "WSFT_Personal"' @click.stop>
				<a @click='goUrl("/order/address")'>地址管理&nbsp;&nbsp;Address Management</a>
				<a @click='goUrl("/order/orders")'>我的訂單&nbsp;&nbsp;My Order</a>
				<!-- <a :href="item.Href" v-for='item in item.Childs' :key='item.Code'>{{item.Label}}&nbsp;&nbsp;{{item.LabelEN}}</a> -->
			</div>
		</div>
		<newCustomer :value='newValue' @close='close' @login='goLogin' />
		<PromoCode :products='PromoModel' :show='PromoModelShow' :opType='PromoModelType' @showPromoCode='showPromoCode'></PromoCode>
		<Modal v-model="showModal" footer-hide>
			<div class="modal-content">
				<div v-html='modalContent.Content'></div>
			</div>
		</Modal>
		<Modal v-model="showFeedbackModal" title='留言反饋' :styles='{width:"640px",top:"0"}' footer-hide>
			<Feedback v-if='showFeedbackModal' />
		</Modal>
	</div>
</template>

<script>
import mixin from "./mixin.js";
export default {
	mixins: [mixin],
};
</script>

<style lang='scss' scoped>
@import "@/style/mixin";
@import "@/style/common";
.nav {
	z-index: 9999;
	width: 100vw;
	background-color: white;
	// border-bottom: 1px solid rgba(238, 238, 238, 1);
	box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
	height: 0.8rem;
	display: flex;
	align-items: center;
	position: fixed;
	.logo {
		margin: 0 0.3rem;
		// height: 0.3rem;
		width: auto;
		user-select: none;
		img {
			height: 0.3rem;
		}
	}
	.items {
		display: flex;
		.item {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 0 0.2rem;
			height: 0.8rem;
			@include fontSize($font-size-17);
			cursor: pointer;
			color: #515a6e;
			position: relative;
			.top-link {
				text-align: center;
				.en {
					@include fontSize($font-size-15);
				}
			}
			a:hover {
				color: $theme-color;
			}
			&:hover:after {
				left: 0;
				content: "";
				display: block;
				width: 100%;
				position: absolute;
				bottom: 0;
				border-bottom: 2px solid $theme-color;
				animation: stretch-width 0.2s ease-in-out;
	
			}
		}
		.active:after {
			content: "";
			display: block;
			left: 0;
			width: 100%;
			position: absolute;
			bottom: 0;
			border-bottom: 2px solid $theme-color;
			animation: stretch-width 0.2s ease-in-out; // border-bottom: 2px solid $theme-color;
		}
		.sep1 {
			display: flex;
			align-items: center;
		}
	}
	.search {
		width: 12.2%;
		.input {
			margin: auto;
			// max-width: 600px;
			display: block;
		}
		.search-btn {
			outline: none;
			&:hover,
			&:focus {
				outline: none;
				background-color: transparent;
				box-shadow: none;
			}
		}
	}
	.icon-btns {
		position: relative;
		display: flex;
		right: 0;
		justify-self: flex-end;
		.active:after {
			content: "";
			display: block;
			width: 100%;
			position: absolute;
			left: 0;
			bottom: 0;
			border-bottom: 2px solid $theme-color;
			animation: stretch-width 0.2s ease-in-out; // border-bottom: 2px solid $theme-color;
		}

		.item {
			// flex:1;
			margin: 0 0.2rem;
			display: flex;
			text-align: center;
			flex-direction: column;
			cursor: pointer;
			height: 1rem;
			align-items: center;
			justify-content: center;
			position: relative;
			color: #333;
			@include fontSize($font-size-16);
			.en {
				@include fontSize($font-size-15);
			}
			&:hover:after {
				left: 0;
				position: absolute;
				bottom: 0;
				content: "";
				display: block;
				width: 100%;
				border-bottom: 2px solid $theme-color;
				animation: stretch-width 0.2s ease-in-out;
			}
			.icon {
				display: block;
				margin: auto;
				width: 0.2rem;
				margin-bottom: 5px;
			}
		}
	}
}
.dropmenus {
	z-index: 999;
	position: fixed;
	top: 1rem;
	width: 100vw;
	left: 0;
	max-height: 600px;
	background-color: white;
	overflow-y: scroll;
	padding-top: 4px;
	animation: stretch-height 0.25s ease-in-out;
	.content {
		margin: 20px 5.21vw 40px;
		display: flex;
	}
	.desc {
		margin: 10px 0;
	}
	.menu-box {
		flex: 1;
		display: flex;
		justify-content: space-around;
		.sub-menu {
			.title {
				color: #333;
				font-weight: bold;
				@include fontSize($font-size-20);
			}
			.sub2-menu {
				flex-direction: column;
				display: flex;
			}
		}
		.menu {
			margin: 10px 0;
			&:hover {
			}
		}
	}
	.products {
		flex-direction: column;
		margin-left: 40px;
		.sub-menu {
			.title {
				display: block;
				font-weight: normal;
				@include fontSize($font-size-16);
				margin-bottom: 5px;
			}
		}
	}
	box-shadow: 0 3px 5px 1px rgba(0, 0, 0, 0.2);
}
.help-center {
	overflow: hidden;
	position: absolute;
	width: 3rem;
	left: -0.9rem;
	margin: 0;
	padding: 0;
	.content {
		margin: 0;
		overflow: hidden;
	}
	.help {
		padding: 10px 0;
		flex-direction: column;
		align-items: center;
		margin-left: 0;
		.sub-menu {
			.title {
				display: block;
				font-weight: normal;
				@include fontSize($font-size-16);
				margin-bottom: 5px;
			}
		}
	}
}
.myo-hover {
	z-index: 999;
	position: absolute;
	cursor: auto;
	top: 1rem;
	left: -13vw;
	background-color: white;
	box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
	.reg-login {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 23.44vw;
		height: 18.23vw;
		position: relative;
	}
	.welcome {
		color: black;
		font-weight: bold;
		@include fontSize($font-size-23);
		margin-top: 2.08vw;
	}
	.btn {
		width: 19.79vw;
		@include fontSize($font-size-20);
		border-radius: 40px;
		height: 3.13vw;
		font-weight: bold;
	}
	.reg {
		margin-top: 2.6vw;
		color: white;
	}
	.login {
		border: 3px solid white;
		margin-top: 2.08vw;
		color: $theme-color;
		background-color: white;
		border-color: $theme-color;
	}
}
.contact {
	z-index: 999;
	position: absolute;
	cursor: auto;
	top: 0.81rem;
	left: 12.87rem;
	width: 3rem;
	padding-bottom: 20px;
	// height: 18.23vw;
	box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
	background-color: #fff;
	display: flex;
	flex-direction: column;
	a {
		display: block;
		margin-top: 20px;
		@include fontSize($font-size-16);
		text-align: center;
		&:hover {
			color: $theme-color;
		}
	}
}
.loadType {
	height: 300px;
	position: relative;
}
.modal-content {
	margin: 20px;
	display: flex;
	flex-direction: column;
	.item {
		display: flex;
		margin: 10px 0;
		@include fontSize($font-size-16);
		.label {
			width: 100px;
		}
		.value {
			flex: 1;
		}
	}
	a {
		color: #333;
	}
	a:hover {
		color: $theme-color;
	}
}
.login-info {
	width: 3.8rem;
	margin: 20px 0;

	padding: 0 0.4rem;
	// width: 100%;
	.info {
		display: flex;
		//align-items: center;
		//justify-content:center;
	}
	.head-img {
		border-radius: 80px;
		overflow: hidden;
		height: 80px;
		width: 80px;
		margin-right: 30px;
		img {
			height: 80px;
			width: 80px;
		}
	}
	.user {
		@include fontSize($font-size-18);
		display: flex;
		align-items: center;
		justify-content: center;
		height: 0.3rem;
		width: 2rem;
		line-height: 0.3rem;
		.vipno {
			// flex:1;
		}
		.name {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}
	.logout {
		width: 0.8rem;
		height: 0.3rem;
		// margin-left: 20px;
		// margin-top: 10px;
		border-radius: 30px;
	}
	.selectOrder {
		margin-top: 10px;
		text-align: center;
		a {
			@include fontSize($font-size-18);
			&:hover {
				color: $theme-color;
			}
			//padding-right: 2vw;
		}
	}
}

.left-info {
	@include fontSize($font-size-17);
}
.sep {
	padding: 0 0.14rem;
	color: #333;
	@include fontSize($font-size-17);
}
.unLogin {
	color: $theme-color;
}
.right-mid {
	display: flex;
	align-items: center;
	@include fontSize($font-size-17);
	& > .item {
		display: flex;
		align-items: center;
		height: 0.4rem;
		position: relative;
		cursor: pointer;
		&:hover {
			color: $theme-color;
		}
	}
}

@keyframes stretch-width {
	0% {
		width: 0;
	}
	100% {
		width: 100%;
	}
}
@keyframes stretch-height {
	0% {
		height: 0;
	}
	100% {
		height: auto;
	}
}
</style>